const DetailedReportPage = () => {
    return <div className="p-5">Ini adalah halaman Detail Report</div>;
  };
  
  export default DetailedReportPage;
  